// ScrollContext.tsx
import { createContext, useContext, RefObject } from 'react';

type ScrollRefType = RefObject<HTMLDivElement | null>;

export const ScrollContext = createContext<ScrollRefType | null>(null);

export const useScrollRef = () => {
  const context = useContext(ScrollContext);
  if (!context) throw new Error("useScrollRef must be used within ScrollContext.Provider");
  return context;
};
